export default __webpack_public_path__ + "static/drachma-0afe5550f07901a3a79a1cf5081cefd5.jpeg";